import React from "react";
import { ComponentElementsRichText } from "../../../graphql/generated/graphql";

function RichText({
  html,
  __typename,
}: ComponentElementsRichText): JSX.Element {
  return (
    <div
      className="componentText prose text-base"
      dangerouslySetInnerHTML={{ __html: html || "" }}
      data-component-name={__typename}
    />
  );
}

export { RichText };
